import * as yup from 'yup';
import validator from 'validator';

import { BirthDateSchema } from '@utils/form-validation/common-schemas';
import { isTcknPossiblyValid } from '@utils/text';

import type { Body } from '../../hooks/flight';
import { GenderValidator } from '../validation-helper';

const DateSchema = (message = 'Doğum tarihi') =>
  yup
    .string()
    .customValidation({
      validator: (value) => {
        const result = validator.isDate(value, { format: 'DD/MM/YYYY' });
        return result;
      },
      invalid: `Lütfen  geçerli bir  ${message} giriniz.`,
      empty: `${message} alanı boş bırakılamaz.`,
    })
    .required('Doğum tarihi alanı boş bırakılamaz.');

const TravelerSchemaFactory: () => yup.SchemaOf<
  Pick<
    Body['travelers'][number],
    | 'firstName'
    | 'lastName'
    | 'birthDate'
    | 'gender'
    //| 'hesCode'
    | 'passaportNumber'
    | 'passaportExpireDate'
    | 'cCode'
    | 'identityNumber'
  >
> = () =>
  yup.object({
    firstName: yup.string().required('Ad alanı boş bırakılamaz.'),
    lastName: yup.string().required('Soyad alanı boş bırakılamaz.'),
    birthDate: BirthDateSchema(),
    gender: GenderValidator,
    id: yup.string(),
    hasTurkishIdentificationNumber: yup.boolean(),
    // hesCode: yup.mixed().when('hasTurkishIdentificationNumber', {
    //   is: (hasTurkishIdentificationNumber: boolean) =>
    //     hasTurkishIdentificationNumber !== false,
    //   // then: yup.string().customValidation({
    //   //   validator: isHesCodePossiblyValid,
    //   //   invalid: 'Lütfen geçerli bir HES Kodu giriniz',
    //   //   empty: 'HES Kodu alanı boş bırakılamaz.',
    //   // }),
    //   otherwise: yup.mixed(),
    // }),
    //hesCode: yup.string(),
    passaportNumber: yup.mixed().when('isDomesticFlight', {
      is: (isDomesticFlight: boolean) => !isDomesticFlight,
      then: yup.string().required('Pasaport No alanı boş bırakılamaz.'),
      otherwise: yup.mixed().when('hasTurkishIdentificationNumber', {
        is: (hasTurkishIdentificationNumber: boolean) =>
          !hasTurkishIdentificationNumber,
        then: yup.string().required('Pasaport No alanı boş bırakılamaz.'),
        otherwise: yup.mixed(),
      }),
    }),
    passaportExpireDate: yup.mixed().when('isDomesticFlight', {
      is: (isDomesticFlight: boolean) => !isDomesticFlight,
      then: DateSchema('Pasaport geçerlilik tarihi'),
      otherwise: yup.mixed(),
    }),
    cCode: yup.mixed().when('isDomesticFlight', {
      is: (isDomesticFlight: boolean) => !isDomesticFlight,
      then: yup.string().required('Ülke alanı zorunlu alandır'),
      otherwise: yup.mixed(),
    }),
    identityNumber: yup.mixed().when('hasTurkishIdentificationNumber', {
      is: true,
      then: yup.string().customValidation({
        validator: isTcknPossiblyValid,
        empty: 'TC Kimlik No alanı boş bırakılamaz.',
        invalid: 'Lütfen Geçerli bir TC Kimlik No Giriniz',
      }),
      otherwise: yup.mixed(),
    }),
  });

const TravelersValidationSchema = yup.array().of(TravelerSchemaFactory());

export const BodySchema = yup.object({
  travelers: TravelersValidationSchema,
});
